// src/views/Admin/Locales/LocalPage/components/LocalHero/LocalHero.tsx

import React from 'react';
import { HiOutlineBuildingOffice2 } from 'react-icons/hi2';
import { FiUsers, FiBarChart2, FiHash } from 'react-icons/fi';
import './LocalHero.scss';

interface LocalHeroProps {
  name: string;
  localId: number;
  isActive: boolean;
  totalUsers: number;
  activeUsers: number;
  totalSessions: number;
  onStatusClick?: () => void;
}

const LocalHero: React.FC<LocalHeroProps> = ({
  name,
  localId,
  isActive,
  totalUsers,
  activeUsers,
  totalSessions,
  onStatusClick
}) => {
  return (
    <div className="local-hero">
      <div className="local-hero-gradient" />
      <div className="local-hero-content">
        <div className="local-hero-icon">
          <HiOutlineBuildingOffice2 size={42} />
        </div>
        <div className="local-hero-info">
          <div className="local-hero-title">
            <h1>{name}</h1>
            <button 
              className={`status-badge clickable ${isActive ? 'active' : 'inactive'}`}
              onClick={onStatusClick}
              title="Click para cambiar estado"
            >
              <span className="status-dot" />
              {isActive ? 'Activo' : 'Inactivo'}
            </button>
          </div>
          <div className="local-hero-meta">
            <span className="meta-item">
              <FiHash size={14} />
              ID: {localId}
            </span>
            <span className="meta-divider">•</span>
            <span className="meta-item">
              <FiUsers size={14} />
              {totalUsers} usuarios ({activeUsers} activos)
            </span>
            <span className="meta-divider">•</span>
            <span className="meta-item">
              <FiBarChart2 size={14} />
              {totalSessions} sesiones históricas
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocalHero;
